import React from 'react';

/**
 * An agent's mark, drawn from the path data in its manifest.
 *
 * The colour comes from the same file, so an agent is recognisable at a glance wherever it appears
 * — the marketplace, the configuration list, a result panel — without any of those screens
 * hard-coding which agent is which.
 */
const AgentIcon = ({ agent, size = 40, className = '' }) => {
  const color = agent?.color || '#64748b';
  const paths = agent?.icon || [];

  return (
    <span
      className={`inline-flex shrink-0 items-center justify-center rounded-xl ${className}`}
      style={{ width: size, height: size, backgroundColor: `${color}1f`, color }}
      aria-hidden="true"
    >
      <svg
        viewBox="0 0 24 24" width={size * 0.6} height={size * 0.6} fill="none"
        stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"
      >
        {paths.map(path => <path key={path} d={path} />)}
      </svg>
    </span>
  );
};

export default AgentIcon;
